module.exports = __webpack_public_path__ + "static/media/bg-count.b8e96ba0.png";